module.exports = __webpack_public_path__ + "static/media/judgeneil.0592ab35.jpeg";